import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, reviewsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, reviewsActions);

export default slice.reducer;
